import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ButtonStyleTypes } from '../../atoms/buttons/enums.js';
import { LSRecentSearchesFieldName, getRecentSearches } from '../../organisms/search-bar/index.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import img$1 from '../../../../assets/images/search.svg.js';
import img from '../../../../assets/images/clear-input.svg.js';
import css_248z from './search-form.scss.js';

class SearchForm extends s {
    constructor() {
        super(...arguments);
        this.rtl = false;
        this.showClearButton = false;
        this.searchTerm = '';
        this.buttonDisabled = true;
        this.inputEl = null;
        this.inputWrapper = null;
        this.recentSearches = [];
        this.onSearchTermChange = (e) => {
            if (e.target.value === '') {
                this.buttonDisabled = true;
                this.renderRoot.querySelector('form').classList.add('empty');
            }
            else {
                this.buttonDisabled = false;
                this.renderRoot.querySelector('form').classList.remove('empty');
            }
        };
        this.onKeyDown = (e) => {
            // only e.keyCode works on android 'Go' key
            const isEnterKey = e.code === 'Enter' || e.keyCode === 13;
            if (!isEnterKey)
                return;
            e.preventDefault();
            if (!this.buttonDisabled)
                this.submitForm();
        };
    }
    updateRecentSearches(searchTerm) {
        this.recentSearches.push(searchTerm);
        if (this.recentSearches.length > 3) {
            this.recentSearches.splice(0, 1);
        }
        localStorage.setItem(LSRecentSearchesFieldName, JSON.stringify(this.recentSearches));
    }
    submitForm() {
        this.updateRecentSearches(this.shadowRoot.querySelector('.search-input').value);
        this.shadowRoot.querySelector('form').submit();
    }
    clearInput(e) {
        e.preventDefault();
        this.renderRoot.querySelector('form').classList.add('empty');
        this.inputEl.value = '';
        this.buttonDisabled = true;
        this.inputEl.focus();
    }
    handleFocus() {
        var _a;
        (_a = this.inputWrapper) === null || _a === void 0 ? void 0 : _a.classList.add('focus');
    }
    handleBlur() {
        var _a;
        (_a = this.inputWrapper) === null || _a === void 0 ? void 0 : _a.classList.remove('focus');
    }
    renderClearInput() {
        return x `<button class="clear-input" @click="${this.clearInput}" aria-label="clear"><img src="${img}" aria-hidden="true"></button>`;
    }
    firstUpdated() {
        this.inputEl = this.renderRoot.querySelector('input[name="q"]');
        this.inputWrapper = this.renderRoot.querySelector('.input-wrapper');
        this.inputEl.value = this.searchTerm;
        this.inputEl.dispatchEvent(new Event('keyup'));
        this.recentSearches = getRecentSearches(LSRecentSearchesFieldName);
    }
    render() {
        return x `<form class="form ${this.rtl || isRTL() ? 'rtl' : ''}" action="${this.searchPageUrl}"><p class="search-title">${this.searchTitle}</p><div class="input-wrapper"><input class="search-input" type="text" name="q" aria-label="${this.searchTitle}" @keyup="${this.onSearchTermChange}" @input="${this.onSearchTermChange}" @focus="${this.handleFocus}" @blur="${this.handleBlur}" @keydown="${this.onKeyDown}" placeholder="${this.searchPlaceholder}" autofocus> ${this.showClearButton ? this.renderClearInput() : null}<icon-button basic class="submit ${this.buttonDisabled ? 'disabled' : ''}" styleType="${ButtonStyleTypes.OUTLINED_DARK}" @click="${this.submitForm}" ?disabled="${this.buttonDisabled}" ariaLabel="${this.searchButtonText}"><img slot="icon" src="${img$1}" alt="" aria-hidden="true"></icon-button></div></form>`;
    }
}
SearchForm.styles = css_248z;
__decorate([
    n({ type: Boolean })
], SearchForm.prototype, "rtl", void 0);
__decorate([
    n({ type: Boolean })
], SearchForm.prototype, "showClearButton", void 0);
__decorate([
    n({ type: String })
], SearchForm.prototype, "searchPageUrl", void 0);
__decorate([
    n({ type: String })
], SearchForm.prototype, "searchTitle", void 0);
__decorate([
    n({ type: String })
], SearchForm.prototype, "searchPlaceholder", void 0);
__decorate([
    n({ type: String })
], SearchForm.prototype, "searchButtonText", void 0);
__decorate([
    n({ type: String })
], SearchForm.prototype, "searchTerm", void 0);
__decorate([
    t()
], SearchForm.prototype, "buttonDisabled", void 0);
customElements.define('search-form', SearchForm);
/* eslint-enable lit-a11y/no-autofocus */

export { SearchForm };
